import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderFormProductDTO } from 'support/types/dtos';

export const useProductIdentifiers = (product: OrderFormProductDTO) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const identifiers = product.identifiers || [];
    const gtin = identifiers.find((id) => id.domain === 'GTIN')?.value;
    const receiverInternal = identifiers.find((id) => id.domain === 'RECEIVER_INTERNAL')?.value;

    const identifierList = [];
    if (gtin) {
      identifierList.push(
        t('orderForms:form.product.gtin', {
          value: gtin,
        }),
      );
    }

    if (receiverInternal) {
      identifierList.push(
        t('orderForms:form.product.articleInternal', {
          value: receiverInternal,
        }),
      );
    }

    return identifierList;
  }, [product, t]);
};
